import { render, staticRenderFns } from "./CompactHeader.vue?vue&type=template&id=72ba51bd&scoped=true&"
import script from "./CompactHeader.vue?vue&type=script&lang=js&"
export * from "./CompactHeader.vue?vue&type=script&lang=js&"
import style0 from "./CompactHeader.vue?vue&type=style&index=0&id=72ba51bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ba51bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VIcon,VSwitch})
